import { AgileColors } from '@atlassian/jira-issue-epic-color-types/src/types.tsx';
import { EPIC_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformJiraEpicToLegacyEpicLink = (epic) => {
	if (epic == null) return null;

	return {
		id: Number(epic.issueId),
		key: epic.key || '',
		done: !!epic.done,
		name: epic.name || '',
		summary: epic.summary || '',
		color: {
			key: epic.color ?? AgileColors.AGILE_COLOR_1,
		},
		// This can only be set from cache handlers
		fromCache: false,
	};
};

export const transformAggEpicLinkToLegacyField: FieldTransformer<typeof EPIC_TYPE> = (node) => {
	if (node.type !== EPIC_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		autoCompleteUrl: node.searchUrl,
		value: transformJiraEpicToLegacyEpicLink(node.epic),
		schema: {
			configuration: null,
			items: null,
			renderer: 'jira-text-renderer',
			type: 'any',
			custom: EPIC_TYPE,
			system: null,
		},
	};
};
